// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77318f5f] {\n  fill: #fff\n}\n.st30[data-v-77318f5f] {\n  fill: #f47277\n}\n", ""]);
// Exports
module.exports = exports;
